import React, { useState, useEffect } from "react";
import "./ApiKeyInput.css";

const ApiKeyInput = ({ onConnectionSuccess }) => {
  const [apiKey, setApiKey] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Check if API key is already stored
    const storedApiKey = localStorage.getItem("trading_api_key");
    if (storedApiKey) {
      setApiKey(storedApiKey);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      // Store the API key
      localStorage.setItem("trading_api_key", apiKey);

      // Notify parent component of successful connection
      onConnectionSuccess(apiKey);
    } catch (err) {
      setError("Failed to connect. Please check your API key and try again.");
      console.error("Connection error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="api-key-container">
      <div className="api-key-form">
        <h2>Welcome to Duke Trading Exchange</h2>
        <p>Please enter your API key to continue</p>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="password"
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              placeholder="Enter your API key"
              required
            />
          </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" disabled={isLoading}>
            {isLoading ? "Connecting..." : "Connect"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ApiKeyInput;
